var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiscal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9h2M6 12h2M6 15h8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3c.966 0 2 .5 2 1.787V9.5h-3M18 3c-.966 0-1 .8-1 1.787V9.5M18 3H5.5C4.12 3 3 4.143 3 5.553v12.24a.5.5 0 00.146.353l1.5 1.5a.5.5 0 00.708 0l1.292-1.292a.5.5 0 01.708 0l1.292 1.292a.5.5 0 00.708 0L11 18l1.646 1.646a.5.5 0 00.708 0l1.292-1.292a.5.5 0 01.708 0l.792.792a.5.5 0 00.854-.353V9.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.857L12.09 11 14 9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFiscal;